import { render, staticRenderFns } from "./GenericTemplate.vue?vue&type=template&id=4ae3de4e&"
import script from "./GenericTemplate.vue?vue&type=script&lang=ts&"
export * from "./GenericTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./GenericTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports